import { MenuItem } from '@mui/material';

const CustomMenuItem = (props) => {
  const { children, ...rest } = props;

  return (
    <MenuItem sx={{ fontSize: '12.5px' }} {...rest}>
      {children}
    </MenuItem>
  );
};

export default CustomMenuItem;
